"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[710],{

/***/ 5710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s9": function() { return /* reexport */ AboutCareer; },
  "yz": function() { return /* reexport */ AboutCheckoutProduct; },
  "E0": function() { return /* reexport */ AboutMainVisual; },
  "mC": function() { return /* reexport */ OurVision; },
  "g2": function() { return /* reexport */ Overview; },
  "SZ": function() { return /* reexport */ Technology; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(2228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ../../packages/global-styles/index.ts
var global_styles = __webpack_require__(9059);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ./public/asset/about/04-banner/banner@2x.png
/* harmony default export */ var banner_2x = ({"src":"/_next/static/media/banner@2x.3de1f123.png","height":1601,"width":2401,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAARVBMVEWBh459cGmnmI9NS044LCtMOjEpIR6di4OdmJRkZWeNhoKooJx+gIRsUkhcTECTj418e3tYU06rr7KdoqeSeW12TkF3YVSbGt+nAAAACnRSTlP+/////f///v7+UhpilwAAAAlwSFlzAAALEwAACxMBAJqcGAAAADBJREFUeJwFwQkCABAIBMANhXJf/3+qGYScXDRlwLPrzAIUulW9QGZ/tsuAtHao0vobVwFxy7GXWgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
// EXTERNAL MODULE: ./components/Common/CommonWrappers.tsx
var CommonWrappers = __webpack_require__(5564);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(6577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../packages/global-styles/MainButton.tsx
var MainButton = __webpack_require__(8920);
// EXTERNAL MODULE: ../../packages/assets/icons.tsx
var icons = __webpack_require__(1089);
// EXTERNAL MODULE: ./styles/breakPoints.ts
var breakPoints = __webpack_require__(3081);
;// CONCATENATED MODULE: ./components/About/AboutCareer.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "margin-top:56px; height: 56px;"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100vw;\n  height: 744px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto;\n\n  @media screen and (min-width: 1440px) {\n    width: 100%;\n    max-width: 1200px;\n    padding: 0 96px;\n  }\n  @media screen and (min-width: 1240px) and (max-width: 1439px) {\n    width: 100%;\n    padding: 0 96px;\n  }\n  @media screen and (min-width: 905px) and (max-width: 1239px) {\n    width: 100%;\n    padding: 0 56px;\n  }\n  @media screen and (min-width: 600px) and (max-width: 904px) {\n    width: 100%;\n    padding: 0;\n  }\n  @media screen and (max-width: 599px) {\n    width: 100%;\n    padding: 0;\n  }\n  @media screen and (max-width: 1239px) {\n    height: 652px;\n  }\n\n  .ac-inner-container {\n    position: relative;\n    height: 360px;\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    border-radius: 16px;\n    overflow: hidden;\n  }\n  @media screen and (max-width: 904px) {\n    height: fit-content;\n    .ac-inner-container {\n      border-radius: 0;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #fff;\n  text-align: center;\n  span {\n    display: block;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










var AboutCareer = function() {
    var locale = (0,router.useRouter)().locale;
    if (locale === "en") return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutCareerContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "ac-inner-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonWrappers/* ImgBackgroundWrapper */.Yo, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: banner_2x.src,
                        layout: "fill",
                        alt: "About bluedot",
                        className: "target-img",
                        objectFit: "cover",
                        sizes: "(min-width: 906px) 90vw, (min-width: 600px) 88vw, (max-width: 599px) 80vw",
                        quality: 70
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AboutCareerH3KR, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "블루닷과 함께 성장해 나갈"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "열정 가득한 인재를 찾고 있습니다."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MainButton/* MainButton */.c, {
                    injectInlineStyles: {
                        width: "328px"
                    },
                    injectCssStyles: [
                        (0,breakPoints/* generateCssStyle */.m)({
                            "margin-top": "32px",
                            height: "48px"
                        }),
                        breakPoints/* mediaQueryStyle.M */.Pm.M(_templateObject()), 
                    ],
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* GoToIcon */.A5, {}),
                    tag: "a",
                    href: "https://blue-dot.career.greetinghr.com/",
                    buttonType: "default-w",
                    changeIconColor: true,
                    target: "_blank",
                    iconPosition: "right",
                    text: "채용페이지 바로가기"
                })
            ]
        })
    });
};
var AboutCareerContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "AboutCareer__AboutCareerContainer",
    componentId: "sc-34b5b60a-0"
})(_templateObject1());
var AboutCareerH3KR = (0,styled_components_browser_esm/* default */.ZP)(global_styles/* H3KR */.nX).withConfig({
    displayName: "AboutCareer__AboutCareerH3KR",
    componentId: "sc-34b5b60a-1"
})(_templateObject2());

// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(9097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/About/AboutCheckoutProduct.tsx

function AboutCheckoutProduct_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            margin-top: 56px;\n            height: 56px;"
    ]);
    AboutCheckoutProduct_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AboutCheckoutProduct_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  color: #fff;\n  width: 100vw;\n  height: 434px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  flex-direction: column;\n  @media screen and (max-width: 600px) {\n    height: 271px;\n  }\n"
    ]);
    AboutCheckoutProduct_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var AboutCheckoutProduct = function() {
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AboutCheckoutProductContainer, {
        children: [
            locale === "en" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles.H2, {
                        children: "Check out the products of BLUEDOT"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles.H2, {
                        children: "for the online video service"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles.H2, {
                        children: "cost reduction."
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* H2KR */.Zj, {
                        children: "온라인 동영상 서비스"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* H2KR */.Zj, {
                        children: "비용절감을 위한 블루닷의"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* H2KR */.Zj, {
                        children: "제품들을 확인해보세요."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/product/sr1sr2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainButton/* MainButton */.c, {
                    buttonType: "default-w",
                    tag: "a",
                    text: locale === "en" ? "Go to Product page" : "제품페이지 바로가기",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* NormalArrowIcon */.LS, {}),
                    iconPosition: "right",
                    injectInlineStyles: {
                        width: "328px",
                        height: "56px"
                    },
                    injectCssStyles: [
                        (0,breakPoints/* generateCssStyle */.m)({
                            height: "48px",
                            "margin-top": "32px"
                        }),
                        breakPoints/* mediaQueryStyle.L */.Pm.L(AboutCheckoutProduct_templateObject()), 
                    ]
                })
            })
        ]
    });
};
var AboutCheckoutProductContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "AboutCheckoutProduct__AboutCheckoutProductContainer",
    componentId: "sc-825b4a0c-0"
})(AboutCheckoutProduct_templateObject1(), global_styles/* BBINDIGO */._4);

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./public/asset/about/00-main-visual/main-visual-img.png
/* harmony default export */ var main_visual_img = ({"src":"/_next/static/media/main-visual-img.5ed20d0b.png","height":810,"width":1921,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAGFBMVEUHEBcNKz8LIC8SOlMdU3IJGCMXQl0bHB5C4o7xAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAH0lEQVR4nAXBgQEAAAjCoGlm/38cIGuSCtZpZ7nDMjwEBwBJeP0qjwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":3});
// EXTERNAL MODULE: ../../node_modules/seamless-scroll-polyfill/lib/scroll.js + 1 modules
var lib_scroll = __webpack_require__(5378);
;// CONCATENATED MODULE: ./components/About/AboutMainVisual.tsx

function AboutMainVisual_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "margin-top:56px;"
    ]);
    AboutMainVisual_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AboutMainVisual_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    AboutMainVisual_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












var KO = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "ko-wrapper",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: "블루닷은 시스템 반도체와 인공지능을 활용한 빠르고 지능적인 영상처리 및 영상압축 기술을 클라우드 데이터 센터를 통해 서비스하는 벤처 회사입니다."
            })
        })
    });
};
var EN = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "en-wrapper-pc",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "BLUEDOT is a startup that utilizes Semiconductor Design and"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Deep Learning to provide Fast and Intelligent Video"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Processing and Compression technologies through Cloud Data Center."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "en-wrapper-mo",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "BLUEDOT is a startup that utilizes"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Semiconductor Design and"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Deep Learning to provide Fast and"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Intelligent Video Processing and"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Compression technologies through"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Cloud Data Center."
                        })
                    })
                ]
            })
        ]
    });
};
var AboutMainVisual = /*#__PURE__*/ (0,react.memo)(function() {
    var locale = (0,router.useRouter)().locale;
    var handleClickLearnMore = function() {
        var $heightContainer = document.querySelector(".main-section-container");
        if ($heightContainer) {
            (0,lib_scroll/* scrollTo */.X5)(window, {
                top: $heightContainer.getBoundingClientRect().height,
                behavior: "smooth"
            });
        }
    };
    //
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AboutMainVisualContainer, {
        className: "main-section-container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonWrappers/* ImgBackgroundWrapper */.Yo, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: main_visual_img.src,
                    layout: "fill",
                    alt: "About bluedot",
                    className: "target-img",
                    objectFit: "cover",
                    sizes: "(min-width: 906px) 90vw, (min-width: 600px) 88vw, (max-width: 599px) 80vw",
                    loading: "eager",
                    quality: 60,
                    priority: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CommonWrappers/* MainVisualInnerContainer */.rO, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(global_styles.H1, {
                        className: "main-typo",
                        as: "h2",
                        children: [
                            "About ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "BLUEDOT"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "desc-text-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "anim-wrapper",
                            children: locale === "en" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EN, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(KO, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MainButton/* MainButton */.c, {
                        buttonType: "default-w",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AboutLearnMoreArrow */.wG, {}),
                        iconPosition: "right",
                        injectCssStyles: [
                            (0,breakPoints/* generateCssStyle */.m)({
                                "margin-top": "32px",
                                animation: "txtAnimation 0.8s 1.5s cubic-bezier(0.4, 0, 0.2, 1) backwards"
                            }),
                            breakPoints/* mediaQueryStyle.M */.Pm.M(AboutMainVisual_templateObject()), 
                        ],
                        injectInlineStyles: {
                            width: "328px",
                            height: "56px"
                        },
                        text: locale === "en" ? "Learn more" : "더 알아보기",
                        onClick: handleClickLearnMore
                    })
                ]
            })
        ]
    });
});
AboutMainVisual.displayName = "AboutMainVisual";
var AboutMainVisualContainer = (0,styled_components_browser_esm/* default */.ZP)(CommonWrappers/* MainVisualOuterContainer */.XY).withConfig({
    displayName: "AboutMainVisual__AboutMainVisualContainer",
    componentId: "sc-a5827f75-0"
})(AboutMainVisual_templateObject1());

;// CONCATENATED MODULE: ./public/asset/about/03-section3/section3-img.png
/* harmony default export */ var section3_img = ({"src":"/_next/static/media/section3-img.f8a8f407.png","height":1081,"width":1921,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAPFBMVEX2+vzj6/OHnrTO2uPv9PdZf6Hs7vHc5e6+z935+/1JZYOisMGRqr/47+zW09jVztN8aW2KjqGjiYvm6vBrufAkAAAAFHRSTlPy2aS+2Ie+2L7yh6WlpaSkh4iJy0Jod/gAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAuSURBVHicBcEHAgAREACxwVbcKf9/rATITAAvIlLciWZmLYI51vePWlE9d3ftDxLoARVjAgjoAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});
// EXTERNAL MODULE: ./components/Home/BannerItems.tsx
var BannerItems = __webpack_require__(2486);
;// CONCATENATED MODULE: ./components/About/OurVision.tsx

function OurVision_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-y: hidden;\n  span {\n    color: ",
        ";\n  }\n"
    ]);
    OurVision_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function OurVision_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n  overflow-y: hidden;\n  span {\n    color: ",
        ";\n  }\n"
    ]);
    OurVision_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function OurVision_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      .vision-title {\n        animation: ",
        " 0.8s cubic-bezier(0.4, 0, 0.2, 1) forwards;\n      }\n      .vision-top {\n        overflow-y: hidden;\n        .anim-wrapper {\n          animation: ",
        " 0.8s 0.2s cubic-bezier(0.4, 0, 0.2, 1)\n            forwards;\n        }\n      }\n      .vision-bottom {\n        .anim-wrapper {\n          animation: ",
        " 1.2s 0.4s cubic-bezier(0.4, 0, 0.2, 1)\n            forwards;\n        }\n      }\n    "
    ]);
    OurVision_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  .o-v-inner-wrapper {\n    width: 100%;\n    height: 1080px;\n    margin-top: 220px;\n    position: relative;\n  }\n  .vision-title {\n    margin: 4px 0 56px;\n    text-align: center;\n    opacity: 0;\n    overflow-y: hidden;\n  }\n  .vision-top {\n    margin: 0 0 146px 0;\n  }\n  .sub-t {\n    overflow-y: hidden;\n  }\n  .anim-wrapper {\n    opacity: 0;\n  }\n  .vision-top-mo {\n    display: none;\n  }\n\n  @media screen and (max-width: 1439px) and (min-width: 1240px) {\n    .o-v-inner-wrapper {\n      margin-top: 160px;\n    }\n    .vision-title {\n      margin: 64px 0 56px;\n    }\n    .vision-top {\n      margin: 0 0 146px;\n    }\n  }\n  @media screen and (max-width: 1239px) and (min-width: 905px) {\n    .o-v-inner-wrapper {\n      margin-top: 0;\n    }\n    .vision-title {\n      margin: 178px 0 32px;\n    }\n    .vision-top {\n      margin: 0 0 96px 0;\n    }\n  }\n  @media screen and (max-width: 904px) and (min-width: 600px) {\n    .o-v-inner-wrapper {\n      height: 840px;\n      margin-top: 0;\n    }\n    .vision-title {\n      margin: 128px 0 16px;\n    }\n    .vision-top {\n      margin: 0 0 56px 0;\n    }\n  }\n  @media screen and (max-width: 599px) {\n    .o-v-inner-wrapper {\n      height: 760px;\n      margin-top: 0;\n    }\n    .vision-title {\n      margin: 88px 0 16px;\n    }\n    .vision-top {\n      margin: 0 0 56px 0;\n    }\n    .vision-top-mo {\n      display: block;\n    }\n    .vision-top-pc {\n      display: none;\n    }\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}








var VisionTopKo = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "vision-top-pc",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleL */.ar, {
                        className: "sub-t",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "anim-wrapper",
                            children: "블루닷은 효율적인 비용으로 네트워크 환경에서 최적의"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleL */.ar, {
                        className: "sub-t",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "anim-wrapper",
                            children: "화질로 동영상 스트리밍 서비스를 가능하게 함으로써"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "vision-top-mo",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleL */.ar, {
                        className: "sub-t",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "anim-wrapper",
                            children: "블루닷은 효율적인 비용으로 네트워크"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleL */.ar, {
                        className: "sub-t",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "anim-wrapper",
                            children: "환경에서 최적의 화질로 동영상"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleL */.ar, {
                        className: "sub-t",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "anim-wrapper",
                            children: "스트리밍 서비스를 가능하게 함으로써"
                        })
                    })
                ]
            })
        ]
    });
};
var VisionBotKo = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "vision-top-pc",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VisionH3KR, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "anim-wrapper",
                            children: [
                                "서비스 기업에게는 ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "비용 절감"
                                }),
                                "을"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VisionH3KR, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "anim-wrapper",
                            children: [
                                "그리고 사용자에게는",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: " 향상된 시청 경험"
                                }),
                                "을"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VisionH3KR, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "anim-wrapper",
                            children: "제공하는데 기여하고자 합니다."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "vision-top-mo",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VisionH3KR, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "anim-wrapper",
                            children: [
                                "서비스 기업에게는 ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "비용 절감"
                                }),
                                "을"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VisionH3KR, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "anim-wrapper",
                            children: [
                                "그리고 사용자에게는",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: " 향상된"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VisionH3KR, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "anim-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "시청 경험을 "
                                }),
                                "제공하는데"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VisionH3KR, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "anim-wrapper",
                            children: "기여하고자 합니다."
                        })
                    })
                ]
            })
        ]
    });
};
var VisionTopEn = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "vision-top-pc",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleL */.ar, {
                        className: "sub-t",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "anim-wrapper",
                            children: "BLUEDOT aims to contribute to cost reduction for Service Providers"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleL */.ar, {
                        className: "sub-t",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "anim-wrapper",
                            children: "and an improved viewing experience for Service Users"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "vision-top-mo",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleL */.ar, {
                        className: "sub-t",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "anim-wrapper",
                            children: "BLUEDOT aims to contribute to cost"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleL */.ar, {
                        className: "sub-t",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "anim-wrapper",
                            children: "reduction for Service Providers and"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleL */.ar, {
                        className: "sub-t",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "anim-wrapper",
                            children: "an improved viewing experience for"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleL */.ar, {
                        className: "sub-t",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "anim-wrapper",
                            children: "Service Users"
                        })
                    })
                ]
            })
        ]
    });
};
var VisionBotEn = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "vision-top-pc",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VisionH3, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "anim-wrapper",
                            children: "by enabling video streaming services with"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VisionH3, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "anim-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Optimal Video Quality "
                                }),
                                "in a given network"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VisionH3, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "anim-wrapper",
                            children: [
                                "environment at",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: " an Efficient Cost."
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "vision-top-mo",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VisionH3, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "anim-wrapper",
                            children: "by enabling video"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VisionH3, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "anim-wrapper",
                            children: "streaming services with"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VisionH3, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "anim-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Optimal Video Quality "
                                }),
                                "in a"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VisionH3, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "anim-wrapper",
                            children: "given network environment"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VisionH3, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "anim-wrapper",
                            children: [
                                "at an",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: " Efficient Cost."
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var OurVision = function(param) {
    var isVisible = param.isVisible, targetRef = param.targetRef;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OurVisionContainer, {
        ref: targetRef,
        isVisible: isVisible,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "o-v-inner-wrapper",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonWrappers/* ImgBackgroundWrapper */.Yo, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: section3_img,
                        layout: "fill",
                        objectFit: "cover",
                        alt: "",
                        className: "target-img",
                        quality: 85,
                        sizes: "(min-width: 906px) 90vw, (min-width: 600px) 85vw, (max-width: 599px) 75vw"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles.H2, {
                    className: "vision-title",
                    children: "Our Vision"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "vision-top",
                    children: locale === "en" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VisionTopEn, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VisionTopKo, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "vision-bottom",
                    children: locale === "en" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VisionBotEn, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VisionBotKo, {})
                })
            ]
        })
    });
};
var VisionH3 = (0,styled_components_browser_esm/* default */.ZP)(global_styles.H3).withConfig({
    displayName: "OurVision__VisionH3",
    componentId: "sc-5a1a2850-0"
})(OurVision_templateObject(), global_styles.BB);
var VisionH3KR = (0,styled_components_browser_esm/* default */.ZP)(global_styles/* H3KR */.nX).withConfig({
    displayName: "OurVision__VisionH3KR",
    componentId: "sc-5a1a2850-1"
})(OurVision_templateObject1(), global_styles.BB);
var OurVisionContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "OurVision__OurVisionContainer",
    componentId: "sc-5a1a2850-2"
})(_templateObject3(), function(param) {
    var isVisible = param.isVisible;
    return isVisible && (0,styled_components_browser_esm/* css */.iv)(OurVision_templateObject2(), BannerItems/* txtAnimation */.Xn, BannerItems/* txtAnimation */.Xn, BannerItems/* txtAnimation */.Xn);
});

;// CONCATENATED MODULE: ./public/asset/about/01-section1/section1-img.png
/* harmony default export */ var section1_img = ({"src":"/_next/static/media/section1-img.2fa44123.png","height":691,"width":1441,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAASFBMVEX5+fbIwLy2vMCMttLo6vClzOWYkIP////r7e3///+BkJNhcIX28vaboKrS1952f5PH2Od/d2imp6OEhpSNnqTEua24vb/PzMx4/OmgAAAAFHRSTlMbeqhmikfvCSYQ7Z08M7vCufb4bi7nl3wAAAAJcEhZcwAACxMAAAsTAQCanBgAAAArSURBVHicBcEHAgAQDASwQ2lrb///qQQiNAcVBbv+Tl0MeHt3ywrAhJiEPxhPAUCccKRzAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":4});
// EXTERNAL MODULE: ./components/Home/ProductTemplate.tsx
var ProductTemplate = __webpack_require__(8040);
;// CONCATENATED MODULE: ./components/About/Overview.tsx

function Overview_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  span {\n    color: ",
        ";\n  }\n"
    ]);
    Overview_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Overview_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      .overview-title {\n        animation: ",
        " 0.8s cubic-bezier(0.4, 0, 0.2, 1) forwards;\n      }\n      .overview-img-wrapper {\n        animation: ",
        " 0.8s 0.2s cubic-bezier(0.4, 0, 0.2, 1)\n          forwards;\n      }\n      .overview-desc-text {\n        animation: ",
        " 1.2s 0.4s cubic-bezier(0.4, 0, 0.2, 1)\n          forwards;\n      }\n    "
    ]);
    Overview_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Overview_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .XS,\n  .MS {\n    display: none;\n  }\n\n  .overview-title {\n    text-align: center;\n    opacity: 0;\n  }\n  @media screen and (min-width: 1440px) {\n    margin: 192px 0 146px;\n    .overview-title {\n      margin-bottom: 56px;\n    }\n  }\n  @media screen and (min-width: 1240px) and (max-width: 1439px) {\n    margin: 192px 0 146px;\n    .overview-title {\n      margin-bottom: 32px;\n    }\n  }\n  @media screen and (min-width: 905px) and (max-width: 1239px) {\n    .XlL {\n      display: none;\n    }\n    .MS {\n      display: block;\n    }\n    margin: 146px 0 96px;\n    .overview-title {\n      margin-bottom: 32px;\n    }\n  }\n  @media screen and (min-width: 600px) and (max-width: 904px) {\n    margin: 96px 0 56px;\n    .XlL {\n      display: none;\n    }\n    .MS {\n      display: block;\n    }\n    .overview-title {\n      margin-bottom: 16px;\n    }\n  }\n  @media screen and (max-width: 599px) {\n    margin: 56px 0 32px;\n    .XlL,\n    .MS {\n      display: none;\n    }\n    .XS {\n      display: block;\n    }\n    .overview-title {\n      margin-bottom: 16px;\n    }\n  }\n  .overview-inner-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    color: ",
        ";\n  }\n  .overview-img-wrapper {\n    position: relative;\n    object-fit: contain;\n    width: 100vw;\n    opacity: 0;\n    max-width: 1240px;\n    margin-bottom: 32px;\n    @media screen and (max-width: 904px) {\n      margin-bottom: 16px;\n    }\n  }\n  .overview-desc-text {\n    width: 100%;\n    text-align: center;\n    padding: 0 15px;\n    overflow-y: hidden;\n    opacity: 0;\n  }\n  ",
        ";\n"
    ]);
    Overview_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








var KoDesc = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "XlL",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OverviewSubtitle, {
                        children: "블루닷은 저지연 라이브 스트리밍, 비디오 컨텐츠 프로덕션, 그리고 컴퓨터 비전 애플리케이션에"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(OverviewSubtitle, {
                        children: [
                            "필요한",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: " 고성능 인코딩, 화질 개선 및 인지화질 최적화 솔루션"
                            }),
                            "을 제공하고 있습니다."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "MS",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OverviewSubtitle, {
                        children: "블루닷은 저지연 라이브 스트리밍, 비디오 컨텐츠 프로덕션,"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(OverviewSubtitle, {
                        children: [
                            "그리고 컴퓨터 비전 애플리케이션에 필요한 ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "고성능"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(OverviewSubtitle, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "인코딩, 화질 개선 및 인지화질 최적화 솔루션"
                            }),
                            "을 제공하고 있습니다."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "XS",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OverviewSubtitle, {
                        children: "블루닷은 저지연 라이브 스트리밍, 비디오 컨텐츠"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OverviewSubtitle, {
                        children: "프로덕션, 그리고 컴퓨터 비전 애플리케이션에"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(OverviewSubtitle, {
                        children: [
                            "필요한 ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "고성능 인코딩, 화질 개선 및 인지화질"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(OverviewSubtitle, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "최적화 솔루션"
                            }),
                            "을 제공하고 있습니다."
                        ]
                    })
                ]
            })
        ]
    });
};
var EnDesc = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "XlL",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(OverviewSubtitle, {
                        children: [
                            "BLUEDOT provides",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: " High Performance Encoding, Video Quality Improvement "
                            }),
                            "and"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(OverviewSubtitle, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Perceptual Quality Optimization "
                            }),
                            "for low latency live streaming, video production,"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OverviewSubtitle, {
                        children: "and computer vision applications."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "MS",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(OverviewSubtitle, {
                        children: [
                            "BLUEDOT provides",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: " High Performance Encoding, Video"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(OverviewSubtitle, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Quality Improvement "
                            }),
                            "and",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: " Perceptual Quality Optimization for"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OverviewSubtitle, {
                        children: "low latency live streaming, video production, and computer"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OverviewSubtitle, {
                        children: "vision applications."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "XS",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(OverviewSubtitle, {
                        children: [
                            "BLUEDOT provides",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: " High Performance"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OverviewSubtitle, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Encoding, Video Quality Improvement"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OverviewSubtitle, {
                        children: "and Perceptual Quality Optimization"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OverviewSubtitle, {
                        children: "for low latency live streaming"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OverviewSubtitle, {
                        children: "video production, and computer vision"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OverviewSubtitle, {
                        children: "applications."
                    })
                ]
            })
        ]
    });
};
var Overview = function(param) {
    var isVisible = param.isVisible, targetRef = param.targetRef;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OverViewContainer, {
        ref: targetRef,
        isVisible: isVisible,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles.H2, {
                className: "overview-title",
                children: "Overview"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "overview-inner-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "overview-img-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: section1_img.src,
                            quality: 100,
                            width: "180px",
                            height: "100px",
                            layout: "responsive",
                            objectFit: "contain",
                            alt: "BLUEDOT provides High Performance Encoding, Video Quality Improvement and Perceptual Quality Optimization for low latency live streaming, video production, and computer vision applications."
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "overview-desc-text",
                        children: locale === "en" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EnDesc, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(KoDesc, {})
                    })
                ]
            })
        ]
    });
};
var OverviewSubtitle = (0,styled_components_browser_esm/* default */.ZP)(global_styles/* SubtitleL */.ar).withConfig({
    displayName: "Overview__OverviewSubtitle",
    componentId: "sc-2a061f00-0"
})(Overview_templateObject(), global_styles.BB);
var OverViewContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "Overview__OverViewContainer",
    componentId: "sc-2a061f00-1"
})(Overview_templateObject2(), global_styles/* BBINDIGO */._4, function(param) {
    var isVisible = param.isVisible;
    return isVisible && (0,styled_components_browser_esm/* css */.iv)(Overview_templateObject1(), BannerItems/* txtAnimation */.Xn, ProductTemplate/* opacityAppear */.Mj, BannerItems/* txtAnimation */.Xn);
});

;// CONCATENATED MODULE: ./public/asset/about/02-section2/section2-img-1.png
/* harmony default export */ var section2_img_1 = ({"src":"/_next/static/media/section2-img-1.54460aa1.png","height":535,"width":801,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAGFBMVEUWIDMhKzwPGSsrNUg6QlNud4ReaXw/R11PXxvBAAAAA3RSTlP+/v6VFoksAAAACXBIWXMAAAsSAAALEgHS3X78AAAAKElEQVR4nB3IwQ0AMAjDQIcE2H/jivpj6UAqfvH0XaLjMTLlzdFh8QAGIABHszO2AwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/asset/about/02-section2/section2-img-2.png
/* harmony default export */ var section2_img_2 = ({"src":"/_next/static/media/section2-img-2.b199b007.png","height":534,"width":801,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAOVBMVEUWExcsNUo5SHtnf6AMChImKDQmLT0fGyEWFyg3Q1lihMZObLdNXHMoMF12k8UiKVZPYpAiLV+Io82AFHe4AAAACHRSTlP8/////////goJZaEAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAvSURBVHicBcEHAsAgDAOxAwKxy+j4/2MrQR9l2Ybu1lwG6PlOlSDrNd8IMrVvRfwW7QEbP5Sf9wAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./components/About/Technology.tsx

function Technology_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      .tech-title {\n        animation: ",
        " 0.8s cubic-bezier(0.4, 0, 0.2, 1) forwards;\n      }\n      .tech-content-left {\n        animation: ",
        " 0.8s 0.2s cubic-bezier(0.4, 0, 0.2, 1)\n          forwards;\n      }\n      .tech-content-right {\n        .anim-wrapper {\n          animation: ",
        " 1.2s 0.4s cubic-bezier(0.4, 0, 0.2, 1)\n            forwards;\n        }\n      }\n    "
    ]);
    Technology_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Technology_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (min-width: 1440px) {\n    width: 100%;\n    max-width: 1200px;\n    margin: 192px auto 146px;\n  }\n  @media screen and (min-width: 1240px) and (max-width: 1439px) {\n    width: calc(100% - 192px);\n    margin: 192px 96px 146px;\n  }\n  @media screen and (min-width: 905px) and (max-width: 1239px) {\n    width: calc(100% - 112px);\n    margin: 146px 56px 96px;\n  }\n  @media screen and (min-width: 600px) and (max-width: 904px) {\n    width: calc(100% - 64px);\n    margin: 96px 32px 56px;\n  }\n  @media screen and (max-width: 599px) {\n    width: calc(100% - 32px);\n    margin: 56px 16px 32px;\n  }\n  .tech-title {\n    opacity: 0;\n    text-align: center;\n    margin-bottom: 56px;\n    @media screen and (max-width: 1239px) and (min-width: 905px) {\n      margin-bottom: 32px;\n    }\n    @media screen and (max-width: 904px) {\n      margin-bottom: 16px;\n    }\n  }\n  .tech-inner-container {\n    width: 100%;\n  }\n  .tech-content-wrapper {\n    display: flex;\n  }\n  .tech-content-wrapper + .tech-content-wrapper {\n    margin-top: 56px;\n  }\n  .tech-content-left {\n    opacity: 0;\n  }\n  .tech-content-left,\n  .tech-content-right {\n    width: 50%;\n    overflow-y: hidden;\n    .anim-wrapper {\n      opacity: 0;\n    }\n    .tech-img-wrapper {\n      width: 100%;\n      position: relative;\n      .tech-img {\n        object-fit: contain;\n        position: relative !important;\n        width: 100% !important;\n        height: unset !important;\n      }\n    }\n    .tech-img-wrapper > span {\n      position: unset !important;\n    }\n  }\n  .tech-content-right {\n    padding-left: 56px;\n    align-self: center;\n    color: ",
        ";\n    overflow-y: hidden;\n  }\n  @media screen and (max-width: 1239px) {\n    .tech-content-wrapper {\n      flex-wrap: wrap;\n      justify-content: center;\n    }\n    .tech-content-left,\n    .tech-content-right {\n      flex-wrap: wrap;\n      flex-shrink: 0;\n      width: 100%;\n      max-width: 800px;\n    }\n    .tech-content-left {\n      display: flex;\n    }\n    .tech-content-right {\n      padding-left: 0;\n      padding-top: 16px;\n    }\n  }\n  @media screen and (max-width: 904px) {\n    .tech-content-left,\n    .tech-content-right {\n      width: 100%;\n    }\n  }\n\n  ",
        ";\n"
    ]);
    Technology_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var KoTextFirst = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "anim-wrapper",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
                    children: "비디오에 특화된 인공지능 모델을 개발하여 CPU와 GPU 같은 범\xad용 컴퓨팅 장치를 활\xad용하는 소프트웨어 솔루션 대신, 프로그래머블 FPGA 프로세서에 시스템 반도체 설계 기술로 솔루션을 구현함으로써 같은 비용으로 더 많은 고화질 동영상 처리 작업을 할 수 있습니다."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
                    children: "API 그리고 FFmpeg 미디어 프레임워크를 지원하기 때문에 반도체의 지식이 없이도 쉽게 솔루션을 사용할 수 있습니다."
                })
            ]
        })
    });
};
var KoTextSecond = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "anim-wrapper",
                children: "영상압축 반도체 IP 분야에서 20년 이상의 R&D와 제품기획 경험을 갖춘 전문가들이 블루닷을 창업하였습니다. 그리고, 인공지능 알고리즘과 반도체 IP를 개발해 온 열정과 창의성 넘치는 젊은 개발자들이 함께 하고 있습니다."
            })
        })
    });
};
var EnTextFirst = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "anim-wrapper",
                children: "By developing AI model specialized for video applications and implementing it with Semiconductor Design technology on a programmable FPGA processor, more High Quality video processing tasks can be performed at the same cost compared to software solutions that utilize general-purpose computing devices such as CPU and GPU."
            })
        })
    });
};
var EnTextSecond = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "anim-wrapper",
                children: "BLUEDOT was founded, a company of experts with more than 20 years of experience in planning products with R&D in Semiconductor IP field of Video Codec. And we are working with young developers full of passion and creativity in the development of Semiconductor IPs and Deep Learning Algorithms."
            })
        })
    });
};
var Technology = function(param) {
    var isVisible = param.isVisible, targetRef = param.targetRef;
    var locale = (0,router.useRouter)().locale;
    var techArray = (0,react.useMemo)(function() {
        return [
            {
                imgSrc: section2_img_1.src,
                alt: "",
                textComponent: locale === "en" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EnTextFirst, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(KoTextFirst, {})
            },
            {
                imgSrc: section2_img_2.src,
                alt: "",
                textComponent: locale === "en" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EnTextSecond, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(KoTextSecond, {})
            }, 
        ];
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TechnologyContainer, {
        ref: targetRef,
        isVisible: isVisible,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles.H2, {
                className: "tech-title",
                children: "Our Technology"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tech-inner-container",
                children: techArray.map(function(tech) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tech-content-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tech-content-left",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tech-img-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "tech-img",
                                        src: tech.imgSrc,
                                        quality: 80,
                                        alt: "",
                                        layout: "fill"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tech-content-right",
                                children: tech.textComponent
                            })
                        ]
                    }, tech.imgSrc);
                })
            })
        ]
    });
};
var TechnologyContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "Technology__TechnologyContainer",
    componentId: "sc-e13af59a-0"
})(Technology_templateObject1(), global_styles/* GRAY50 */.mu, function(param) {
    var isVisible = param.isVisible;
    return isVisible && (0,styled_components_browser_esm/* css */.iv)(Technology_templateObject(), BannerItems/* txtAnimation */.Xn, ProductTemplate/* opacityAppear */.Mj, BannerItems/* txtAnimation */.Xn);
});

;// CONCATENATED MODULE: ./components/About/index.ts








/***/ })

}]);